import mitt from 'mitt';

let emitterInstance: ReturnType<typeof mitt> | null = null;

export type Events =
  | 'auth:session_changed'
  | 'auth:session_expired'
  | 'session:blocked'
  | 'session:unblocked'
  | 'session:policy-violation'
  | 'session:protocol-error'
  | 'session:reconnect-exhausted';

export function generateEventName(eventName: Events, clientId: string) {
  return `${eventName}:${clientId}`;
}

export function getEmitter() {
  if (!emitterInstance) {
    emitterInstance = mitt();
  }

  return emitterInstance;
}
